
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-card--default--icon-color:var(--color-primary-default);
  --sic-card--default--icon-width:100px;
  --sic-card--default--content-padding:var(--spacing-06) var(--spacing-06) var(--spacing-12);
  --sic-card--default--eyebrow-font-size:calc(
    var(--headline-eyebrow-min-font-size)
  );
  --sic-card--default--eyebrow-line-height:calc(
    var(--headline-eyebrow-min-line-height)
  );
  --sic-card--default--heading-font-size:var(--headline-01-font-size-mid);
  --sic-card--default--heading-line-height:var(--headline-01-line-height);
  --sic-card--default--text-color:var(--sic-heading-color);
  --sic-card--default--text-padding-top:var(--spacing-02);
  --sic-card--default--border-color:var(--color-primary-default);
  --sic-card--default--border-width:var(--border-width-thicker);
  --sic-card--default--border-radius:var(--border-radius-rounded-default);
}
`;